import theme from '../themes/default'
import aboutContentImage from '../../images/about-content-bg.png'
import closeImage from '../../images/close-circle.png'

export default {
  wrap: {
    height: '100%',
  },
  'about-wrap': {
    'background-position': 'top center',
    'background-size': '100%',
    'background-repeat': 'no-repeat',
    'background-color': '#d5ad40',
    'min-height': '100%',
  },
  'close-button-wrap': {
    padding: '20px 15px',
  },
  'close-button': {
    width: '45px',
    height: '45px',
    background: '#C54545',
    borderRadius: '50%',
    background: `url(${closeImage})`,
    'background-position': 'center center',
    'background-size': 'cover',
    margin: '0 0 0 auto',
  },
  'content-wrap': {
    background: `url(${aboutContentImage})`,
    'background-repeat': 'no-repeat',
    'background-size': '100%',
    'margin-top': '100px',
    'min-height': '400px',
  },
  content: {
    color: '#fff',
    'padding-left': '15px',
    'padding-right': '15px',
  },
  'title-description': {
    position: 'relative',
  },
  'red-line': {
    position: 'absolute',
    top: '-33px',
    left: '-20px',
    'border-top-right-radius': '8.5px',
    'border-bottom-right-radius': '8.5px',
    width: '78px',
    height: '7px',
    background: '#c54545',
  },
  'green-line': {
    position: 'absolute',
    bottom: '0',
    right: '-15px',
    width: '45px',
    height: '7px',
    'border-top-left-radius': '8.5px',
    'border-bottom-left-radius': '8.5px',
    background: '#4a8ca1',
  },
  title: {
    'font-size': '30px',
    'font-weight': 'bold',
    'letter-spacing': '2px',
  },
  description: {
    'font-size': '12px',
    'font-weight': 'normal',
    padding: '15px 0',
    'letter-spacing': '1.5px',
  },
  'other-description': {
    padding: '20px 0',
    'font-size': '12px',
    'letter-spacing': '1px',
  },
  address: {

  },
  'address-title': {
    padding: '5px 0',
  },
  'address-description': {
    'padding-top': '5px',
    'font-weight': '100',
  },
  'address-zh': {

  },
  'address-en': {
    'padding-top': '5px',
  },
  phone: {
    'padding-top': '30px',
  },
  'phone-description': {
    'padding-top': '5px',
    'font-weight': '100',
  },
  opening: {
    'padding-top': '30px',
  },
  'opening-description': {
    'padding-top': '5px',
    'font-weight': '100',
  },
  'about-intro': {
    'padding-top': '20px',
    'line-height': '1.5',
    '& img': {
      width: '100%',
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/About.js